<template>

  <div class="p-4">

    <RobloxOverviewStats />

    <TabButtons

      :buttons="panelSwitchingButtons"

      :active_button="currentlyVisiblePanel"

      :panel-changed-method="panelChanged"

    ></TabButtons>



    <div

      class="flex flex-col gap-2 justify-center items-center h-full"

      v-if="loading"

    >

      <h2>Fetching analytics data... This might take a few minutes.</h2>

      <LoadingComponent />

    </div>

    <div

      class="flex flex-col gap-2 justify-center items-center h-full"

      v-if="gender_loading && currentlyVisiblePanel === 'gender_table'"

    >

      <h2>Fetching gender data... This might take a few minutes.</h2>

      <LoadingComponent />

    </div>

    <div

      class="flex flex-col gap-2 justify-center items-center h-full"

      v-if="device_type_loading && currentlyVisiblePanel === 'device_type_table'"

    >

      <h2>Fetching device type data... This might take a few minutes.</h2>

      <LoadingComponent />

    </div>



    <!-- Gender Table -->

    <TableComponent

      v-if="currentlyVisiblePanel === 'gender_table' && !gender_loading"

      :table_data="genderTableComputed"

      default_sort_by="Game"

      :default_sort_desc="false"

      :exported_file_name="'gender-percentages-per-game'"

      :show_total_row="false"

      :show_average_row="false"

    ></TableComponent>



    <div v-if="currentlyVisiblePanel === 'age_table'">

      <div

        class="flex flex-col gap-2 justify-center items-center h-full"

        v-if="age_loading"

      >

        <h2>Fetching age data... This might take a few minutes.</h2>

        <LoadingComponent />

      </div>

      <!-- Age Table -->

      <h5 class="p-3 m-1">(Age table has had 'Unknown' column removed)</h5>

      <TableComponent

        v-if="!age_loading"

        :table_data="ageTableComputed"

        total_column_heading_name="Game"

        default_sort_by="Game"

        :default_sort_desc="false"

        :exported_file_name="'age-percentages-per-game'"

        :show_total_row="false"

        :show_average_row="false"

      ></TableComponent>

    </div>



    <!-- Device Type Table -->

    <TableComponent

      v-if="currentlyVisiblePanel === 'device_type_table' && !device_type_loading"

      :table_data="deviceTypeTableComputed"

      default_sort_by="Game"

      :default_sort_desc="false"

      :exported_file_name="'device-type-percentages-per-game'"

      :show_total_row="false"

      :show_average_row="false"

    ></TableComponent>



    <div class="mt-4" v-if="(currentlyVisiblePanel === 'main_table' || currentlyVisiblePanel === 'us_table') && !loading">

      <!-- Date Range Selector -->

      <div class="flex flex-col gap-4 mb-4">

        <!-- Date Inputs and Fetch Button -->

        <div class="flex items-center gap-4">

          <div class="flex items-center">

            <label class="mr-2 font-medium">Start Date:</label>

            <input

              type="date"

              v-model="startDate"

              class="p-2 border rounded-md mr-4"

            />

            <label class="mr-2 font-medium">End Date:</label>

            <input

              type="date"

              v-model="endDate"

              class="p-2 border rounded-md"

            />

          </div>

          <button

            type="submit"

            @click="fetchAnalyticsData"

            class="py-1 px-4 bg-green-500 text-white rounded-md hover:bg-green-600"

          >

            Submit

          </button>

        </div>

        <!-- Buttons for Quick Ranges -->

        <div class="flex gap-2">

          <button

            @click="setRange(7)"

            class="py-1 px-2 bg-blue-200 text-blue-800 hover:bg-blue-300 rounded"

          >

            Last 7 Days

          </button>

          <button

            @click="setRange(30)"

            class="py-1 px-2 bg-blue-200 text-blue-800 hover:bg-blue-300 rounded"

          >

            Last 30 Days

          </button>

          <button

            @click="setRange(60)"

            class="py-1 px-2 bg-blue-200 text-blue-800 hover:bg-blue-300 rounded"

          >

            Last 60 Days

          </button>

          <button

            @click="setRange(90)"

            class="py-1 px-2 bg-blue-200 text-blue-800 hover:bg-blue-300 rounded"

          >

            Last 90 Days

          </button>

        </div>

      </div>



      <!-- Combined Portfolio Data Table -->

      <div>

        <h2 class="text-xl font-semibold mt-6 mb-4">Portfolio Data</h2>

        <TableComponent

          v-if="combinedPortfolioData.length > 0"

          :table_data="combinedPortfolioData"

          :default_sort_by="'Total Visits'"

          :default_sort_desc="true"

          :show_total_row="true"

          :show_average_row="true"

          :exported_file_name="`portfolio-data-${startDate}_to_${endDate}`"

          :total_column_heading_name="'Game'"

        />

        <p v-else class="text-gray-500">

          No data available for the selected date range.

        </p>

      </div>

    </div>

  </div>

</template>



<script>

import axios from "axios";

import TableComponent from "@/components/TableComponent.vue";
import RobloxOverviewStats from "@/components/RobloxOverviewStats.vue";

import gamefamPortfolioData from "@/static_data/gamefam_portfolio_data.json";

import TabButtons from "../components/TabButtons.vue";



export default {

  name: "PortfolioAnalytics",

  components: {

    TableComponent,
    RobloxOverviewStats,

    TabButtons,

  },

  data() {

    return {

      loading: false,

      gender_loading: false,

      age_loading: false,

      device_type_loading: false,

      startDate: null,

      endDate: null,

      currentlyVisiblePanel: "main_table",

      portfolioVisits: [], // Visits data

      portfolioDau: [], // DAU data

      portfolioMau: [], // MAU data

      portfolioSessionLength: [], // Session length data

      portfolioCountryPercentageBreakdown: [], // Country percentage breakdown

      genderTableData: [], // Gender Data

      ageTableData: [], // Age Data

      deviceTypeTableData: [], // Device Type Data

      panelSwitchingButtons: [

        { name: "main_table", text: "Main Table" },

        { name: "age_table", text: "Age %" },

        { name: "gender_table", text: "Gender %" },

        { name: "device_type_table", text: "Device %" },

      ],

    };

  },

  computed: {

    ageTableComputed() {

      if (!Array.isArray(this.ageTableData)) return []



      return this.ageTableData.map(item =>

        Object.fromEntries(

          Object.entries(item).filter(([key]) => key !== 'is_obby')

        )

      )

    },

    genderTableComputed() {

      if (!Array.isArray(this.genderTableData)) return []



      return this.genderTableData.map(item =>

        Object.fromEntries(

          Object.entries(item).filter(([key]) => key !== 'is_obby')

        )

      )

    },

    deviceTypeTableComputed() {

      if (!Array.isArray(this.deviceTypeTableData)) return []



      return this.deviceTypeTableData.map(item =>

        Object.fromEntries(

          Object.entries(item).filter(([key]) => key !== 'is_obby')

        )

      )

    },

    /**

     * Combines all portfolio data into a single table.

     * Each row is merged by place_id and now uses the 'Game' key.

     */

    combinedPortfolioData() {

      const dataMap = {};

      const alpha2Codes = ["US", "AU", "BR", "CA", "DE", "ES", "FR", "GB", "IT", "MX"];



      const parsePercentage = (str) => {

        if (str == null) return 0;

        if (typeof str === "number") return Number.isFinite(str) ? Math.round(str) : 0;

        if (typeof str !== "string") return 0;

        const val = parseFloat(str.replace("%", "").trim());

        return Number.isNaN(val) ? 0 : Math.round(val);

      };



      const clamp = (n, min, max) => Math.min(max, Math.max(min, n));



      const getDaySpan = (startDate, endDate) => {

        if (!startDate || !endDate) return 30;

        const start = new Date(startDate);

        const end = new Date(endDate);

        const diffMs = end - start;

        if (diffMs <= 0) return 30;

        return Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      };



      const getAvgDailyVisits = (totalVisits, daySpan) => {

        if (!totalVisits || !daySpan) return 0;

        return Math.round(totalVisits / daySpan);

      };



      const ensureEntry = (item) => {

        if (!dataMap[item.place_id]) {

          dataMap[item.place_id] = {

            "Place ID": item.place_id,

            Game: item.Game ?? null,

            "Universe ID": item.universe_id ?? null,

            "Total Visits": 0,

            "Avg. Daily Visits": 0,

            "Average DAU": 0,

            "Monthly Active Users": 0,

            "Session Length (mins)": 0,

            US: 0,

            AU: 0,

            BR: 0,

            CA: 0,

            DE: 0,

            ES: 0,

            FR: 0,

            GB: 0,

            IT: 0,

            MX: 0,

            ROW: 0,

            staticSource: false,

          };

        }

      };



      // Merge dynamic portfolio data

      this.portfolioVisits.forEach((item) => {

        ensureEntry(item);

        dataMap[item.place_id]["Total Visits"] = Number(item.total_visits) || 0;

      });

      this.portfolioDau.forEach((item) => {

        ensureEntry(item);

        dataMap[item.place_id]["Average DAU"] = Number(item.average_dau) || 0;

      });

      this.portfolioMau.forEach((item) => {

        ensureEntry(item);

        dataMap[item.place_id]["Monthly Active Users"] = Number(item.average_mau) || 0;

      });

      this.portfolioSessionLength.forEach((item) => {

        ensureEntry(item);

        dataMap[item.place_id]["Session Length (mins)"] = Number(item.average_session_length) || 0;

      });



      // Merge country breakdown (dynamic)

      const parseCountryBreakdown = (item) => {

        const copy = { ...item };

        delete copy.place_id;

        delete copy.universe_id;

        delete copy.Game;

        if ("Total" in copy) delete copy.Total;

        return copy;

      };



      this.portfolioCountryPercentageBreakdown.forEach((item) => {

        ensureEntry(item);

        const breakdown = parseCountryBreakdown(item);



        let knownSum = 0;



        alpha2Codes.forEach((code) => {

          const pct = parsePercentage(breakdown[code]);

          dataMap[item.place_id][code] += pct;

          knownSum += pct;

        });



        // ROW is now calculated as "leftover" (100 - sum of tracked country codes)

        // We intentionally ignore any backend-provided ROW/other keys.

        dataMap[item.place_id].ROW += clamp(100 - knownSum, 0, 100);

      });



      // Merge static Gamefam data

      const daySpan = getDaySpan(this.startDate, this.endDate);

      gamefamPortfolioData.forEach((item) => {

        const placeId = item.Game || `static_${Date.now()}`;

        ensureEntry({ place_id: placeId, Game: item.Game });

        dataMap[placeId].staticSource = true;



        // Static data mappings:

        const dailyVisits = Number(item["Daily Visits"]) || 0;

        dataMap[placeId]["Avg. Daily Visits"] = dailyVisits;

        dataMap[placeId]["Total Visits"] = dailyVisits * daySpan;

        dataMap[placeId]["Average DAU"] = Number(item["Avg. DAU"]) || 0;

        dataMap[placeId]["Monthly Active Users"] = Number(item["Monthly Active Users"]) || 0;

        dataMap[placeId]["Session Length (mins)"] = parseFloat(item["Session Length (mins)"]) || 0;



        // Merge Geo Breakdown

        const geo = item["Geo Breakdown"] || {};



        let knownSum = 0;



        alpha2Codes.forEach((code) => {

          const pct = parsePercentage(geo[code]);

          dataMap[placeId][code] += pct;

          knownSum += pct;

        });



        dataMap[placeId].ROW += clamp(100 - knownSum, 0, 100);

      });



      // Compute Avg. Daily Visits for non-static data

      const allEntries = Object.values(dataMap);

      allEntries.forEach((entry) => {

        if (!entry.staticSource) {

          entry["Avg. Daily Visits"] = getAvgDailyVisits(entry["Total Visits"], daySpan);

        }

      });



      // Append '%' to country breakdown fields and remove unused keys

      allEntries.forEach((row) => {

        alpha2Codes.forEach((code) => {

          row[code] = `${row[code]}%`;

        });

        row.ROW = `${row.ROW}%`;

        delete row["Place ID"];

        delete row["Universe ID"];

        delete row.staticSource;

      });



      // Reorder columns

      return allEntries.map((row) => {

        return {

          Game: row.Game,

          "Total Visits": row["Total Visits"],

          "Avg. Daily Visits": row["Avg. Daily Visits"],

          "Average DAU": row["Average DAU"],

          "Monthly Active Users": row["Monthly Active Users"],

          "Session Length (mins)": row["Session Length (mins)"],

          US: row.US,

          AU: row.AU,

          BR: row.BR,

          CA: row.CA,

          DE: row.DE,

          ES: row.ES,

          FR: row.FR,

          GB: row.GB,

          IT: row.IT,

          MX: row.MX,

          ROW: row.ROW,

        };

      });

    },

  },

  methods: {

    fetchAgeTableData() {

      this.age_loading = true;

      this.$http

        .get(`/portfolio/age-table`)

        .then(({ data }) => {

          this.ageTableData = data;

          this.$notify({ type: "success", text: "Fetched age table data" });

        })

        .catch((error) => {

          this.$notify({ type: "error", text: "Failed to fetch age table data" });

          console.error(error.message);

        })

        .finally(() => {

          this.age_loading = false;

        });

    },

    fetchGenderTableData() {

      this.gender_loading = true;

      this.$http

        .get(`/portfolio/genders-table`)

        .then(({ data }) => {

          this.genderTableData = data;

          this.$notify({ type: "success", text: "Fetched gender table data" });

        })

        .catch((error) => {

          console.error(error.message);

          this.$notify({ type: "error", text: "Failed to fetch gender table data" });

        })

        .finally(() => {

          this.gender_loading = false;

        });

    },

    fetchDeviceTypeTableData() {

      this.device_type_loading = true;

      this.$http

        .get(`/portfolio/device-type-breakdown`)

        .then(({ data }) => {

          this.deviceTypeTableData = data;

          this.$notify({ type: "success", text: "Fetched device type table data" });

        })

        .catch((error) => {

          console.error(error.message);

          this.$notify({ type: "error", text: "Failed to fetch device type table data" });

        })

        .finally(() => {

          this.device_type_loading = false;

        });

    },

    panelChanged(panelName) {

      this.currentlyVisiblePanel = panelName;

    },


    formatDate(dateObj) {

      const year = dateObj.getFullYear();

      const month = String(dateObj.getMonth() + 1).padStart(2, "0");

      const day = String(dateObj.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;

    },

    setRange(days) {

      const today = new Date();

      const oneDayAgo = new Date(today.getTime() - 24 * 60 * 60 * 1000);

      const rangeStart = new Date(oneDayAgo.getTime() - (days - 1) * 24 * 60 * 60 * 1000);

      this.startDate = this.formatDate(rangeStart);

      this.endDate = this.formatDate(oneDayAgo);

      this.fetchAnalyticsData();

    },

    async fetchAnalyticsData() {

      if (!this.startDate || !this.endDate) {

        alert("Please select a start and end date.");

        return;

      }

      console.log("Fetching analytics data for date range:", this.startDate, this.endDate);

      try {

        this.loading = true;

        const [

          visitsResponse,

          dauResponse,

          mauResponse,

          sessionLengthResponse,

          countryPercentageBreakdown,

        ] = await Promise.all([

          axios.get("/portfolio/visits", {

            params: { startDate: this.startDate, endDate: this.endDate },

            headers: { Accept: "application/json" },

          }),

          axios.get("/portfolio/dau", {

            params: { startDate: this.startDate, endDate: this.endDate },

            headers: { Accept: "application/json" },

          }),

          axios.get("/portfolio/mau", {

            params: { startDate: this.startDate, endDate: this.endDate },

            headers: { Accept: "application/json" },

          }),

          axios.get("/portfolio/average-session-length", {

            params: { startDate: this.startDate, endDate: this.endDate },

            headers: { Accept: "application/json" },

          }),

          axios.get("/portfolio/country-percentage-breakdown", {

            params: { startDate: this.startDate, endDate: this.endDate },

            headers: { Accept: "application/json" },

          }),

        ]);



        console.log("Visits Data:", visitsResponse.data);

        console.log("DAU Data:", dauResponse.data);

        console.log("MAU Data:", mauResponse.data);

        console.log("Session Length Data:", sessionLengthResponse.data);

        console.log("Country Percentage Breakdown:", countryPercentageBreakdown.data);



        // Process visits data

        if (Array.isArray(visitsResponse.data)) {

          this.portfolioVisits = visitsResponse.data.map((item) => ({

            place_id: item.place_id,

            Game: item.Game,

            universe_id: item.universe_id,

            total_visits: item.total_visits,

          }));

        } else {

          console.error("Unexpected format for visits data:", visitsResponse.data);

          alert("Failed to fetch portfolio visits due to unexpected data format.");

        }



        // Process DAU data

        if (Array.isArray(dauResponse.data)) {

          this.portfolioDau = dauResponse.data.map((item) => ({

            place_id: item.place_id,

            Game: item.Game,

            universe_id: item.universe_id,

            average_dau: item.average_dau,

          }));

        } else {

          console.error("Unexpected format for DAU data:", dauResponse.data);

          alert("Failed to fetch portfolio DAU due to unexpected data format.");

        }



        // Process MAU data

        if (Array.isArray(mauResponse.data)) {

          this.portfolioMau = mauResponse.data.map((item) => ({

            place_id: item.place_id,

            Game: item.Game,

            universe_id: item.universe_id,

            average_mau: item.average_mau,

          }));

        } else {

          console.error("Unexpected format for MAU data:", mauResponse.data);

          alert("Failed to fetch portfolio MAU due to unexpected data format.");

        }



        // Process session length data

        if (Array.isArray(sessionLengthResponse.data)) {

          this.portfolioSessionLength = sessionLengthResponse.data.map((item) => ({

            place_id: item.place_id,

            Game: item.Game,

            universe_id: item.universe_id,

            average_session_length: item.average_session_length,

          }));

        } else {

          console.error("Unexpected format for session length data:", sessionLengthResponse.data);

          alert("Failed to fetch session length data due to unexpected data format.");

        }



        // Process country breakdown data

        if (Array.isArray(countryPercentageBreakdown.data)) {

          this.portfolioCountryPercentageBreakdown = countryPercentageBreakdown.data.map((item) => ({

            place_id: item.place_id,

            universe_id: item.universe_id,

            Game: item.Game,

            ...item,

          }));

        } else {

          console.error("Unexpected format for Country Percentage data:", countryPercentageBreakdown.data);

          alert("Failed to fetch country percentage breakdown due to unexpected data format.");

        }

      } catch (error) {

        console.error("Error fetching analytics data:", error);

        alert("Failed to fetch analytics data. Please try again.");

      } finally {

        this.loading = false;

      }

    },

  },

  mounted() {


    this.fetchGenderTableData();

    this.fetchAgeTableData();

    this.fetchDeviceTypeTableData();

    const today = new Date();

    const oneDayAgo = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    const sixtyDaysAgo = new Date(oneDayAgo.getTime() - 59 * 24 * 60 * 60 * 1000);

    this.startDate = this.formatDate(sixtyDaysAgo);

    this.endDate = this.formatDate(oneDayAgo);

    this.fetchAnalyticsData();

  },

};

</script>



<style scoped>

/* Additional styling can go here if needed */

</style>